<template>
  <div>
    <div class="row">
      <div class="col mb-2">
        <p-button
          type="info"
          simple
          class="p-0"
          title="Recharger la page initiale"
          v-if="hasSearched"
        >
          <span @click="onCancel">
            <i class="ti-close me-2"></i>
            Annuler la recherche
          </span>
        </p-button>
      </div>
    </div>

    <card class="card parc-search-card" title="Recherche">
      <b-form>
        <!-- Recherche générique -->
        <div class="row">
          <!-- Region -->
          <b-form-group
            id="input-group-region"
            class="col-md-4"
            label="Région"
            label-for="input-region"
            description=""
          >
            <b-form-select
              :options="options.regions"
              v-model="searchParams.regionInsee"
              @change="onChangeRegion"
            >
            </b-form-select>
          </b-form-group>

          <!-- Département -->
          <b-form-group
            id="input-group-departement"
            class="col-md-4"
            label="Département"
            label-for="input-departement"
            description=""
          >
            <b-form-select
              :options="options.departements"
              v-model="searchParams.departementInsee"
              :disabled="searchParams.regionInsee == null"
              @change="onChangeDepartement"
            ></b-form-select>
          </b-form-group>

          <!-- Commune -->
          <b-form-group
            id="input-group-commune"
            class="col-md-4"
            label="Commune"
            label-for="input-commune"
            description=""
          >
            <b-form-select
              :options="options.communes"
              v-model="searchParams.communeInsee"
              :disabled="searchParams.departementInsee == null"
            ></b-form-select>
          </b-form-group>
        </div>

        <div class="row">
          <!-- Statut de saisie -->
          <b-form-group
            id="input-group-statutSaisie"
            class="col-md-4"
            label="Statut de saisie"
            label-for="input-statutSaisie"
            description=""
          >
            <b-form-select
              :options="options.statutSaisieList"
              v-model="searchParams.statutSaisieId"
            >
            </b-form-select>
          </b-form-group>

          <!-- Statut Administratif -->
          <b-form-group
            id="input-group-statutAdministratif"
            class="col-md-4"
            label="Statut Administratif"
            label-for="input-statutAdministratif"
            description=""
          >
            <b-form-select
              :options="options.statutAdministratifList"
              v-model="searchParams.statutAdministratifId"
            >
            </b-form-select>
          </b-form-group>

          <!-- Statut Parc -->
          <b-form-group
            id="input-group-statutParc"
            class="col-md-4"
            label="Statut du parc"
            label-for="input-statutParc"
            description=""
          >
            <b-form-select
              :options="options.statutParcList"
              v-model="searchParams.statutParcId"
            ></b-form-select>
          </b-form-group>
        </div>

        <div class="row">
          <!-- Etat du Parc -->
          <b-form-group
            id="input-group-etatParc"
            class="col-md-4"
            label="Etat du parc"
            label-for="input-etatParc"
            description=""
          >
            <b-form-select
              :options="options.etatParcList"
              v-model="searchParams.etatParcId"
            ></b-form-select>
          </b-form-group>

          <!-- Numéro ICPE -->
          <div class="col-md-4">
            <b-form-group
              id="input-group-numeroICPE"
              class="input-group-numeroICPE "
              label="Numéro ICPE"
              label-for="input-numeroICPE"
              description=""
            >
              <b-form-input
                v-model="searchParams.numeroICPE"
                placeholder="Entrer un Numéro ICPE"
                v-on:keydown.enter.prevent="onPressEnter"
              >
              </b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col text-center mb-2">
            <p-button type="info" round @click.native.prevent="onSubmit">
              Rechercher
            </p-button>
          </div>
        </div>
      </b-form>
    </card>

    <!-- Alertes -->
    <div class="alert alert-warning rounded" role="alert" v-if="isEmptySearch">
      Aucun parc ne correspond à votre recherche
    </div>
  </div>
</template>
<script>
import { collectiviteService } from "@/service/collectivite.service.js";
import { lexiqueService } from "@/service/lexique.service.js";

import Card from "./Cards/Card.vue";
import { mapGetters } from "vuex";
import { BForm, BFormGroup, BFormSelect, BFormInput } from 'bootstrap-vue-next'

export default {
  components: {
    Card,
    BForm,
    BFormGroup,
    BFormSelect,
    BFormInput
  },
  data() {
    return {
      searchParams: {
        communeInsee: null,
        departementInsee: null,
        regionInsee: null,
        statutSaisieId: null,
        statutAdministratifId: null,
        statutParcId: null,
        etatParcId: null,
        numeroICPE: null
      },
      options: {
        communes: [],
        departements: [],
        regions: [],
        statutSaisieList: [],
        statutAdministratifList: [],
        statutParcList: [],
        etatParcList: []
      }
    };
  },
  computed: {
    ...mapGetters({
      isAdministrateur: "isAdministrateur",
      selectedDroit: "selectedDroit",
      regions: "regions",
      departements: "departements",
      departementsByInseeRegion: "departementsByInseeRegion",
      isCollectivites: "isCollectivites",
      isEmptySearch: "isEmptySearch",
      hasSearched: "hasSearched",
      reloadParcsAndSearchParams: "reloadParcsAndSearchParams"
    })
  },
  watch: {
    reloadParcsAndSearchParams() {
      this.onClickMesParcs();
    }
  },
  created() {
    this.getRegions();
    this.getLexStatutSaisie();
    this.getLexStatutAdministratif();
    this.getLexStatutParc();
    this.getLexEtatParc();
    this.reloadSearchParams();
    this.onClickMesParcs();
  },
  methods: {
    onSubmit() {
      this.$store.dispatch("saveSearchParams", this.searchParams);
      this.$emit("search-parcs");
    },
    onCancel() {
      this.$store.dispatch("resetSearchParams");
      this.searchParams = {
        communeInsee: null,
        departementInsee: null,
        regionInsee: null,
        statutSaisieId: null,
        statutAdministratifId: null,
        statutParcId: null,
        etatParcId: null,
        numeroICPE: null
      };
      this.options.departements = [];
      this.options.communes = [];
      this.administrateurInitSearchParams();
      this.$emit("search-parcs");
    },
    onChangeRegion() {
      if (this.searchParams.regionInsee != null) {
        const departements = this.departementsByInseeRegion(
          this.searchParams.regionInsee
        );

        this.options.departements = departements.map(departement => {
          return {
            value: departement.inseeDepartement,
            text: `${departement.nomDepartementMaj} (${departement.inseeDepartement})`
          };
        });
        this.options.departements.unshift({
          value: null,
          text: "-- Sélectionnez un département --"
        });
      } else {
        this.options.departements = [];
      }
      this.searchParams.departementInsee = null;
      this.options.communes = [];
      this.searchParams.communeInsee = null;
    },
    onChangeDepartement() {
      if (this.searchParams.departementInsee != null) {
        collectiviteService
          .getCommunesByInseeDep(this.searchParams.departementInsee)
          .then(data => {
            const communes = data;
            this.options.communes = communes.map(commune => {
              return {
                value: commune.inseeCommune,
                text: `${commune.nomCommuneMaj} (${commune.inseeCommune})`
              };
            });
            this.options.communes.unshift({
              value: null,
              text: "-- Sélectionnez une commune --"
            });
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.options.communes = [];
      }
      this.searchParams.communeInsee = null;
    },
    getRegions() {
      if (this.options.regions.length == 0) {
        this.options.regions = this.regions.map(region => {
          return {
            value: region.inseeRegion,
            text: region.nomRegionMaj
          };
        });
        this.options.regions.unshift({
          value: null,
          text: "-- Sélectionnez une région --"
        });
      }
      this.administrateurInitSearchParams();
    },
    getLexStatutSaisie() {
      if (this.options.statutSaisieList.length == 0) {
        lexiqueService
          .getLexStatutSaisie()
          .then(data => {
            if (data) {
              const statutSaisieList = data;
              this.options.statutSaisieList = statutSaisieList.map(
                statut => {
                  return {
                    value: statut.id,
                    text: statut.libelle
                  };
                }
              );
              this.options.statutSaisieList.unshift({
                value: null,
                text: "-- Sélectionnez un statut de saisie --"
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    getLexStatutAdministratif() {
      if (this.options.statutAdministratifList.length == 0) {
        lexiqueService
          .getLexStatutAdministratif()
          .then(data => {
            if (data) {
              const statutAdministratifList = data;
              this.options.statutAdministratifList = statutAdministratifList.map(
                statut => {
                  return {
                    value: statut.id,
                    text: statut.libelle
                  };
                }
              );
              this.options.statutAdministratifList.unshift({
                value: null,
                text: "-- Sélectionnez un statut administratif --"
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    getLexStatutParc() {
      if (this.options.statutParcList.length == 0) {
        lexiqueService
          .getLexStatutParc()
          .then(data => {
            if (data) {
              const statutParcList = data;
              this.options.statutParcList = statutParcList.map(statut => {
                return {
                  value: statut.id,
                  text: statut.libelle
                };
              });
              this.options.statutParcList.unshift({
                value: null,
                text: "-- Sélectionnez un statut de parc --"
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    getLexEtatParc() {
      if (this.options.etatParcList.length == 0) {
        lexiqueService
          .getLexEtatParc()
          .then(data => {
            if (data) {
              const etatParcList = data;
              this.options.etatParcList = etatParcList.map(etat => {
                return {
                  value: etat.id,
                  text: etat.libelle
                };
              });
              this.options.etatParcList.unshift({
                value: null,
                text: "-- Sélectionnez un etat de parc --"
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    administrateurInitSearchParams() {
      if (this.isAdministrateur && !this.hasSearched) {
        this.searchParams.regionInsee = this.selectedDroit.region;
        this.onChangeRegion();
      }
    },
    reloadSearchParams() {
      if (this.hasSearched) {
        this.searchParams = this.$store.getters.searchParams;
        // Chargement des régions
        if (this.searchParams.regionInsee != null) {
          const departement = this.searchParams.departementInsee;
          const commune = this.searchParams.communeInsee;
          this.onChangeRegion();

          // Chargement des départements et de la commune sélectionnée
          if (departement != null) {
            this.searchParams.departementInsee = departement;
            this.onChangeDepartement();
            this.searchParams.communeInsee = commune;
          }
        }
      }
    },
    formatSelectOptions(str) {
      const splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        if (splitStr[i] != "d") {
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
      }
      return splitStr.join(" ");
    },
    // Empêche le rechargement de la page si la touche 'entrée' est pressée dans l'input
    onPressEnter(event) {
      if (event) event.preventDefault();
      this.onSubmit();
    },
    // Recharge la page initiale si click sur l'onglet du menu 'Mes Parcs'
    onClickMesParcs() {
      if (this.reloadParcsAndSearchParams == true) {
        this.onCancel();
        this.$store.dispatch("parcsAndSearchParamsReloaded");
      }
    }
  }
};
</script>
<style lang="scss">
.parc-search-card {
  margin-bottom: 26px;

  .card-body {
    margin: 0 6px;
  }

  .input-group {
    &-numeroICPE {
      margin-right: 0;
      padding-right: 0;
    }
  }

  .form-group,
  .input-group-numeroICPE{
    input {
      border: #ced4da solid 1px;
      background-color: #ffffff;
      &::placeholder {
        color: #495057;
      }
    }
  }
}
</style>
